/**
 * Blog stuff.
 * 
 * @todo -- Use Alpine.data and a cleaner way to detect things changing through here. I want to not see $( window ).on(xyz) really. --- Luke
 */

import $ from "jquery";
import Alpine from "alpinejs";
import initDebounce from "../utilities/debounce";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const AuthorTrigger = () => {
    const authorTop = $(".blog-author-top");
    const authorBottom = $(".blog-author-bottom");

    if (authorTop.length && authorBottom.length) {
        ScrollTrigger.create({
            trigger: authorBottom,
            start: "top bottom",
            onEnter: () => {
                gsap.set(authorTop, {
                    opacity: 0
                })
            },
            onLeaveBack: () => {
                gsap.set(authorTop, {
                    opacity: 1
                })
            }   
        })
    }
}

export default function Blog() { 
    initDebounce( $ );
    $( init );

    AuthorTrigger();
}

var page = 1;

function init() { 
    // No point initialising all of this if we aren't on blog page (or blog tag).
    if ( ( ! window.document.body.classList.contains( "blog" ) ) && ( ! window.document.body.classList.contains( "category" ) ) ) {
        return;
    }
    
    // Alpine seems to call the event multiple times so we have to debounce it.
    $( window ).on( { 
        "categories-changed": $.debounce( 150, onChangeCategory ) 
    } );

    // Bind the loadmore button to work with the categories system we have.
    $( "#load-more-articles" ).on( "click", onLoadmore );
}

/**
 * Called when the array of categories is updated.
 */
function onChangeCategory() { 
    // Reset the page cursor since we've updated the category.
    page = 1;

    // Load the articles in.
    loadArticles( 
        selectedCategories(), 
        page,
        orderDirection()    
    ).then( response => {
        if ( ! response.html ) {
            return;
        }

        $( "#load-more-articles" ).removeClass( "hidden" ).addClass( "primary-btn" );
        $( "#article-list" ).html( response.html );
    } );
}

/**
 * Called when the user wants to load more articles.
 */
function onLoadmore() { 
    page++;

    // Load the next page.
    loadArticles( 
        selectedCategories(), 
        page,
        orderDirection() 
    ).then( response => { 
        if ( ! response.html ) {
            return;
        }

        $( "#article-list" ).append( response.html );

        if ( response.isEnd === true ) {
            $( "#load-more-articles" ).addClass( "hidden" ).removeClass( "primary-btn" );
        } else { 
            $( "#load-more-articles" ).removeClass( "hidden" ).addClass( "primary-btn" );
        }
    } );
}

/**
 * Gets array of currently selected categories.
 * 
 * @returns {String[]}
 */
export function selectedCategories() {
    const categoryFilter = $( "#category-filter" ).get( 0 );

    if ( ! categoryFilter ) { 
        return [];
    }

    // Clone the data in the proxy.
    return Object.assign( [], ( Alpine || window.Alpine )?.$data( categoryFilter )?.selectedCategories );
}

/**
 * Currently selected order-by direction.
 * 
 * @returns {String}
 */
export function orderDirection()  {
    const order = $( "#sort-by" ).val();

    return order.trim() === "" ? "DESC" : order;
}

/**
 * Loads a set of articles from the server.
 * 
 * @param {String[]} categories 
 * @param {Number} page 
 * @returns {Promise<{}>}
 */
async function loadArticles( categories, page, order = "DESC" ) { 
    const response = await $.ajax( {
        url: `${ window.location.origin }/wp-admin/admin-ajax.php`,
        method: "POST",
        data: { 
            action:     "load_more_articles",
            page:       page,
            categories: categories,
            order:      order
        }
    } );

    if ( ( ! response ) || ( ! response.status ) ) {
        console.error( "Failure to load more articles.." );
        return null; 
    }

    return response;
}